<script>

import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
//import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Program Device Information",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Program Device Information",
            program_info: [],
            programList:[],
            productList:[],
            program_id: '',
            product_id: '',
            sku: '',
            partner_sku: '',
            tenure: '',
            price: '',
            device_cost: '',
            program_fee: '',
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY H:m:s')
            }
        },
        get_program_device_by_id(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program_device/edit/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.program_device_info = response.data;
                    this.program_id = this.program_device_info[0].program_id;
                    this.product_id = this.program_device_info[0].product_id;
                    this.sku = this.program_device_info[0].sku;
                    this.partner_sku = this.program_device_info[0].partner_sku;
                    this.tenure = this.program_device_info[0].tenure;
                    this.price = this.getCurrency() +' '+this.program_device_info[0].price;
                    this.device_cost = this.getCurrency() +' '+this.program_device_info[0].device_cost;
                    this.program_fee = this.getCurrency() +' '+this.program_device_info[0].program_fee;
                
                    console.log(this.program_device_info);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        update_program_device(e)
        {
            this.ButtonSeen=true;
            e.preventDefault()

            const posting_ = { 
                program_id: this.program_id,
                product_id: this.product_id,
                sku: this.sku,
                partner_sku: this.partner_sku,
                tenure: this.tenure,
                price: this.price,
                device_cost: this.device_cost,
                program_fee: this.program_fee,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'program_device/update/'+this.$route.params.id, posting_)
            .then(response => {
                if (response) {
                  this.ButtonSeen=false; 
                  alert(response.data.msj); 
                  this.$router.push({ name: 'programDevice' });                      
                }
                else{
                    this.ButtonSeen=false;
                    console.log('tak ok');
                }
            });
        },

        //raw data----------------------------------------------------------

        get_program(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.programList = response.data;
                    console.log(this.programList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_product(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'product/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.productList = response.data;
                    console.log(this.productList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
        getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },

        //raw data----------------------------------------------------------
    },

    components: {
        Layout,
        PageHeader, 
    },

    mounted() {     
        this.get_program_device_by_id();   
        this.get_program();
        this.get_product();   
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <h4><span class="badge badge-soft-primary badge-border">Edit Program Device</span></h4>
            </div>
          </div>
          <div class="card-body">
            <div class="live-preview">
                <form @submit="update_program_device">
                    <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="program_name" class="form-label">Program Name *</label>
                        </div>
                        <div class="col-lg-7">
                            <select v-model="program_id" class="form-select mb-3" arial-label="Default select example" required>
                                <option value="">--- Select Program ---</option>
                                <option v-for="(item, index) in programList" :key="index" :value="item.id" >
                                    {{ item.program_name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="product_name" class="form-label">Product Name *</label>
                        </div>
                        <div class="col-lg-7">
                            <select v-model="product_id" class="form-select mb-3" arial-label="Default select example" required>
                                <option value="">--- Select Product ---</option>
                                <option v-for="(item, index) in productList" :key="index" :value="item.id" >
                                    {{ item.product_name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="sku" class="form-label">SKU *</label>
                        </div>
                        <div class="col-lg-7">
                            <input v-model='sku' type="text" class="form-control" id="sku" required/>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="partner_sku" class="form-label">Partner SKU *</label>
                        </div>
                        <div class="col-lg-7">
                            <input v-model='partner_sku' type="text" class="form-control" id="partner_sku" required/>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="tenure" class="form-label">Tenure *</label>
                        </div>
                        <div class="col-lg-7">
                            <select v-model="tenure" class="form-control" data-trigger id="tenure" required>
                                <option value="">--- Select Tenure ---</option>
                                <option value="12">12</option>
                                <option value="24">24</option>
                                <option value="36">36</option>
                                <option value="48">48</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="price" class="form-label">Price *</label>
                        </div>
                        <div class="col-lg-7">
                             <input v-model='price' type="text" class="form-control" id="price" required/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="price" class="form-label">Device Cost *</label>
                        </div>
                        <div class="col-lg-7">
                             <input v-model='device_cost' type="text" class="form-control" id="device_cost" required/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="program_fee" class="form-label">Program Fee *</label>
                        </div>
                        <div class="col-lg-7">
                             <input v-model='program_fee' type="text" class="form-control" id="program_fee" required/>
                        </div>
                    </div>
                
                    <hr class="my-4 text-muted">
                    <div class="text-end col-lg-9">
                        <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <button type="submit" class="btn btn-primary" v-if="this.role != 3">
                            Update
                        </button>
                    </div>
                </form>
            </div>
          </div>
        </div>        
      </div>
    </div>
  </Layout>
</template>
